import BaseAPI from './base/base-api';

class SendToDeveloperAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'sendtodeveloper';
}

export default new SendToDeveloperAPI();
